
import React, { useEffect } from "react";
import Layout from "../../Components/Layout/Layout";
import maintenance from "../../Assets/maintenance.svg";
import "../ErrorAndMaintenance/ErrorAndMaintenance.css";
import logo from "../../Assets/orbit_logo_transparent.png";
const Maintenance = () => {
   useEffect(() => {
            localStorage.removeItem("cns")
            localStorage.removeItem("cip")
            localStorage.removeItem("cdp")
        }, [])
  return (
    <div className="error-outer">
      <div className="mainte-banner">
        <img src={logo} alt="img1" />
      </div>
      <div className="maintenance-main">
        <img src={maintenance} alt="" />
        <div className="our-website-note-two">
          {/* <span className="our-website-note">Important Notice:</span>{" "} */}
          <p className="our-website">We'll be right back!</p>
        </div>
        <p className="our-website">
          Orbit Intel is undergoing a scheduled upgrade. The portal will be temporarily offline starting Thursday and will resume normal operations on Monday morning. We apologize for any inconvenience this may cause, and we appreciate your patience during this maintenance period.
        </p>
        <p className="our-website-mid-row">
          Keep an eye on your email inbox on Monday, where we'll share a detailed overview of all the exciting enhancements and improvements.
        </p>
        <p className="our-website-last">
          For any questions or concerns, please contact the EDA team at: {""}
          <a href="mailto:enterprisedata@orbit.com">
            enterprisedata@orbit.com
          </a>
          .
        </p>
      </div>
    </div>
  );
};
export default Maintenance;
